import loadable from '@loadable/component';

export const ManageAdminsPageContainerLoadable = loadable(
  () => import('./ManageAdminsPageContainer'),
  { resolveComponent: (module) => module.ManageAdminsPageContainer },
);
